<template>
  <article
    class="card"
    v-lp-tagging:productimpression="
      type === 'article' ? null : { data: item.tagging.impression }
    "
    :data-impressions="searchPage ? stringifiedData : null"
  >
    <a
      tabindex="0"
      class="card__content"
      v-hrefsafe="item.link"
      v-lp-tagging:productclick="
        type === 'article' ? null : { data: item.tagging.click }
      "
    >
    <p class="card__tag" v-if="item.vtoAvailable" :class="item.vtoDarkMode ? 'blackBackground' : 'whiteBackground'">
        <svg v-if="item.vtoDarkMode" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.501 1C10.5384 1 5.6875 6.01814 5.6875 12.1864V29.3042C5.6875 30.2393 6.42281 31 7.32674 31H12.0774V30.997C12.0818 30.997 12.0862 31 12.0906 31C12.3624 31 12.5821 30.7722 12.5821 30.4915V27.9166L12.6903 27.9914C12.705 28.0016 12.7207 28.0128 12.7355 28.0229L13.2059 28.3499C13.3922 28.4805 13.574 28.6193 13.7554 28.7581C14.5423 29.3602 15.3563 29.983 16.501 29.983C17.6458 29.983 18.4598 29.3602 19.2467 28.7581C19.4281 28.6193 19.6099 28.4805 19.7957 28.3499L20.2666 28.0229C20.273 28.0183 20.2803 28.0138 20.2867 28.0087C20.3403 27.9721 20.3934 27.935 20.4465 27.8983V30.4916C20.4465 30.7677 20.6598 30.9894 20.9252 30.997V31H25.6757C26.5792 31 27.3145 30.2393 27.3145 29.3042V12.1864C27.3146 6.01814 22.4637 1 16.501 1ZM21.9501 25.4419C21.5116 25.8725 21.0172 26.2554 20.5119 26.6195C20.2484 26.8091 19.983 26.9958 19.7161 27.1803L19.2442 27.5083C19.0471 27.6466 18.8544 27.7935 18.6622 27.9405C17.9731 28.4678 17.3218 28.966 16.501 28.966C15.6802 28.966 15.0289 28.4678 14.3398 27.9405C14.1476 27.7935 13.9549 27.6466 13.7578 27.5083L13.2918 27.1838C13.0259 26.9998 12.7614 26.8142 12.4989 26.6256C11.9907 26.2595 11.4928 25.875 11.0519 25.4419C8.8233 23.2534 8.63655 19.844 8.63655 16.8201C8.63655 14.9601 9.47262 13.1719 10.8735 12.0369C12.1362 11.0133 13.5739 10.2044 14.2885 9.82756C16.9188 15.7885 22.6869 17.0348 24.364 17.2742C24.3419 20.1807 24.0681 23.3622 21.9501 25.4419Z" fill="white"/>
          <line x1="16.5" y1="1.5" x2="16.5" y2="29.5" stroke="white" stroke-dasharray="2 2"/>
          <rect opacity="0.6" x="5" y="1" width="11" height="30" fill="black"/>
        </svg>
        <svg v-else width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.501 1C10.5384 1 5.6875 6.01814 5.6875 12.1864V29.3042C5.6875 30.2393 6.42281 31 7.32674 31H12.0774V30.997C12.0818 30.997 12.0862 31 12.0906 31C12.3624 31 12.5821 30.7722 12.5821 30.4915V27.9166L12.6903 27.9914C12.705 28.0016 12.7207 28.0128 12.7355 28.0229L13.2059 28.3499C13.3922 28.4805 13.574 28.6193 13.7554 28.7581C14.5423 29.3602 15.3563 29.983 16.501 29.983C17.6458 29.983 18.4598 29.3602 19.2467 28.7581C19.4281 28.6193 19.6099 28.4805 19.7957 28.3499L20.2666 28.0229C20.273 28.0183 20.2803 28.0138 20.2867 28.0087C20.3403 27.9721 20.3934 27.935 20.4465 27.8983V30.4916C20.4465 30.7677 20.6598 30.9894 20.9252 30.997V31H25.6757C26.5792 31 27.3145 30.2393 27.3145 29.3042V12.1864C27.3146 6.01814 22.4637 1 16.501 1ZM21.9501 25.4419C21.5116 25.8725 21.0172 26.2554 20.5119 26.6195C20.2484 26.8091 19.983 26.9958 19.7161 27.1803L19.2442 27.5083C19.0471 27.6466 18.8544 27.7935 18.6622 27.9405C17.9731 28.4678 17.3218 28.966 16.501 28.966C15.6802 28.966 15.0289 28.4678 14.3398 27.9405C14.1476 27.7935 13.9549 27.6466 13.7578 27.5083L13.2918 27.1838C13.0259 26.9998 12.7614 26.8142 12.4989 26.6256C11.9907 26.2595 11.4928 25.875 11.0519 25.4419C8.8233 23.2534 8.63655 19.844 8.63655 16.8201C8.63655 14.9601 9.47262 13.1719 10.8735 12.0369C12.1362 11.0133 13.5739 10.2044 14.2885 9.82756C16.9188 15.7885 22.6869 17.0348 24.364 17.2742C24.3419 20.1807 24.0681 23.3622 21.9501 25.4419Z" fill="black"/>
            <line x1="16.5" y1="1.5" x2="16.5" y2="29.5" stroke="black" stroke-dasharray="2 2"/>
            <rect opacity="0.6" x="5" y="1" width="11" height="30" fill="white"/>
        </svg>
        <span>{{item.vtoText}}</span>
      </p>
      <picture
        v-if="item.image"
        class="picture has-aspect-ratio is-9by13-mobile"
      >
        <source
          v-for="srcset in item.image.srcsetlist"
          :key="srcset.src"
          :media="
            (srcset.minwidth ? '(min-width: ' + srcset.minwidth + ')' : '') +
            (srcset.minwidth && srcset.maxwidth ? ' and ' : '') +
            (srcset.maxwidth ? '(max-width: ' + srcset.maxwidth + ')' : '')
          "
          :data-srcset="srcset.src"
        />
        <img
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          :data-src="item.image.src"
          :alt="imageAlt"
          class="lazy"
          aria-hidden="true"
        />
      </picture>

      <h2 class="card__title">
        <span v-if="item.range" class="card__range">{{ item.range }}</span>
        <span
          class="card__name"
          v-titleSup="item.productName || item.title"
        ></span>
      </h2>
      <p class="card__description" v-if="item.claim || item.description" v-htmlsafe="item.claim || item.description"></p>
      <p v-if="item.price" class="card__price">{{ item.price }}</p>
      <div v-if="ratingEnabled && isBvEnabled" class="rating">
        <div data-bv-show="inline_rating" :data-bv-product-id="item.productId"></div>
      </div>
      <product-card-rating
        v-if="ratingEnabled && !isBvEnabled"
        :rating="item.rating"
      ></product-card-rating>
    </a>

    <div class="card__actions" v-if="item.cta">
      <a
        role="button"
        :aria-label="
          item.cta.text && item.title
            ? `${item.cta.text} about ${item.title}`
            : ''
        "
        v-hrefsafe="item.cta.link"
        class="button -secondary"
      >
        <span>{{ item.cta.text }}</span>
      </a>
    </div>
  </article>
</template>
<script>
export default {
  name: 'card',
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    searchPage: {
      type: Boolean,
      default: false,
    },
    imageSizes: {
      type: String,
      default:
        '(min-width: 1600px) 368px, (min-width: 1280px) 288px, (min-width: 1024px) 234px, 50vw',
    },
  },
  computed: {
    stringifiedData() {
      return JSON.stringify(this.item.tagging.impression.ecommerce.impressions);
    },
    imageAlt() {
      return this.item?.image?.altText || '';
    },
    ratingEnabled() {
      return this.item?.rating?.enabled;
    },
    isBvEnabled() {
      return this.item?.isBvEnabled;
    },
  },
};
</script>
